import React from 'react';
import { Icon } from 'antd';
import './button.css';

const button = ({ onClick, disabled = false, className = '', style = {}, text = 'OK', showIcon = false, iconName = 'loading', iconClassName = '' }) => (
    <button onClick={onClick}
        disabled={disabled}
        style={style ? style : {}}
        className={`login-button ${className}`}>
        {text}
        {showIcon &&
            <Icon className={`load-icon ${iconClassName}`} type={iconName} />
        }
    </button>
)

export default button


// WEBPACK FOOTER //
// ./src/App/components/button/button.js